import { ApiServiceProvider } from "@libs/api-service-provider";
import { TranslationServiceProvider } from "@libs/translation-service-provider";
import { BASE_URL } from "@shared/constants";
import { Toaster } from "@libs/design/components/toaster/Toaster";

import { AppRoutes } from "./routes";
import { AppProvider } from "./providers";

function App() {
  return (
    <AppProvider>
      <ApiServiceProvider baseUrl={BASE_URL}>
        <TranslationServiceProvider>
          <Toaster />
          <AppRoutes />
        </TranslationServiceProvider>
      </ApiServiceProvider>
    </AppProvider>
  );
}

export default App;
